// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Represents date or null.
export type NullableDate = Date | null | undefined;

// Compares two nullable dates.
export function compareDates(a: NullableDate, b: NullableDate): number {
    return (a?.getTime() ?? 0) - (b?.getTime() ?? 0);
}
